import httpRequest from '@/request'

const API = {
  MONITOR:'/front/energygov/v1/supervisionDocumentRecord/statistics',
  RANKING:'/front/energygov/v1/supervisionCollectRecordsMonthComprehensive/energyConsumeRanking',
  TRENDS:'/front/energygov/v1/supervisionCollectRecordsMonthComprehensive/energyTrend',
  CONSUMPTIONRATIO:'/front/energygov/v1/supervisionCollectRecordsMonth/consumptionRatio',
  OUTPUT:'/front/energygov/v1/supervisionCollectRecordsMonthComprehensive/outputTrends',
  RANK:'/front/energygov/v1/supervisionCollectRecordsMonthComprehensive/entComprehensiveEnergyConsumeRank',
  MAPDATA:'/front/energygov/v1/supervisionCollectRecordsMonthComprehensive/map',//综合能源消费量地图
}

export function Monitor(data: any) {
  return httpRequest({
    url: API.MONITOR,
    method: 'get',
  })
}

export function Ranking(data:any) {
  return httpRequest({
    url: API.RANKING,
    method: 'get',
    params:data
  })
}

export function energyTrend(data:any) {
  return httpRequest({
    url: API.TRENDS,
    method: 'get',
    params:data
  })
}
export function sumptionRatio(data:any) {
  return httpRequest({
    url: API.CONSUMPTIONRATIO,
    method: 'get',
    params:data
  })
}
export function outputTrends(data:any) {
  return httpRequest({
    url: API.OUTPUT,
    method: 'get',
    params:data
  })
}
export function entComprehensiveEnergyConsumeRank(data:any) {
  return httpRequest({
    url: API.RANK,
    method: 'get',
    params:data
  })
}
export function mapData(params:any){
    return httpRequest({
        url:API.MAPDATA,
        method:'get',
        params
    })
}